export const isReferrerFromWhammyDonatePage = (ref?: string): boolean => {
  const referrer = ref || (typeof document !== 'undefined' ? document.referrer : '')
  if (!referrer) return false

  return /\/campaign\/\d+\/donate(?:\/|$|[?#])/.test(referrer)
}
